const TextQualifierType = {
  SingleQuote: 'SINGLEQUOTE',
  DoubleQuote: 'DOUBLEQUOTE',
  None: 'NONE',
}

class CsvConfig {
  delimiter: any
  textQualifierType: any
  constructor(delimiter: any, textQualifierType: any) {
    this.delimiter = delimiter
    this.textQualifierType = textQualifierType
  }

  get textQualifier() {
    if (this.textQualifierType == TextQualifierType.SingleQuote) return "'"
    else if (this.textQualifierType == TextQualifierType.DoubleQuote) return '"'
    else return null
  }
}
export const csvHelper = (csvData: any, textQualifier = TextQualifierType.DoubleQuote) => {
  const config = new CsvConfig(',', textQualifier)

  const read = (stream: any) => {
    const list = []
    // U+FEFF (UTF-8 BOM), stripped if it survived up to this point
    const normalizedStream = typeof stream === 'string' ? stream.replace(/^﻿/, '') : stream
    const lines = normalizedStream.split('\n')

    for (let line of lines) {
      if (line.trim()) {
        const arr = readCells(line)

        if (!arr) return arr
        if (arr.length) list.push(arr)
      }
    }

    return list
  }

  const readCells = (line: any) => {
    if (!line.trim()) return []
    if (config.textQualifier === null) {
      const arr = line.split(config.delimiter).map((x: any) => x.trim())
      return arr
    }
    const list = []
    const endWithDelimiter = line.replace(/[\n\r]*/g, '').endsWith(config.delimiter)

    while (line.trim().replace(/[\n\r]*/g, '')) {
      const result = readCell(line.replace(/[\n\r]*/g, ''))
      if (!result) return result
      list.push(result.cell)
      line = result.line
    }

    if (endWithDelimiter) list.push(line)

    return list
  }

  const readCell = (line: any) => {
    if (!line.trim()) return { line: '', cell: '' }

    const firstChar = line[0]

    if (firstChar === config.textQualifier) {
      if (line.length < 2) {
        return false
      }

      let index = 1
      while (index < line.length) {
        if (line[index] === config.textQualifier) {
          if (index === line.length - 1) {
            if (!isValidCsvCell(line)) {
              return false
            }
            return { line: '', cell: decodeCsvText(line) }
          } else if (line[index + 1] === config.textQualifier) {
            index += 2
            if (index >= line.length) {
              return false
            }
            continue
          } else if (line[index + 1] === config.delimiter) {
            const cellText = line.substring(0, index + 1)
            if (!isValidCsvCell(cellText)) {
              return false
            }

            const remainText = index + 1 === line.length - 1 ? '' : line.substring(index + 2, line.length)
            return { line: remainText, cell: decodeCsvText(cellText) }
          } else {
            let j = index + 1
            while (j < line.length && (line[j] === '\t' || line[j] === ' ')) {
              j++
            }

            if (line[j] === config.delimiter) {
              const cellText = line.substring(0, j - 1)

              if (!isValidCsvCell(cellText)) {
                return false
              }

              const remainText = j === line.length - 1 ? '' : line.substring(j + 1, line.length)
              return { line: remainText, cell: decodeCsvText(cellText) }
            }

            return false
          }
        } else {
          index++
        }
      }
    } else if (firstChar == config.delimiter) {
      return { line: line.substring(1), cell: '' }
    } else {
      const firstDelimiterPosition = line.indexOf(config.delimiter)
      if (firstDelimiterPosition === -1) {
        if (line.includes(config.textQualifier)) {
          return false
        }
        return { line: '', cell: line }
      } else {
        const cellText = line.substring(0, firstDelimiterPosition)
        if (cellText.includes(config.textQualifier)) {
          return false
        }

        const remainText = firstDelimiterPosition === line.length ? '' : line.substring(firstDelimiterPosition + 1)
        return { line: remainText, cell: cellText }
      }
    }

    return false
  }

  const decodeCsvText = (text: any) => {
    if (!text.trim()) return text

    text = text.replace(new RegExp(`${config.textQualifier}${config.textQualifier}`, 'g'), `${config.textQualifier}`)
    if (text[0] === config.textQualifier) {
      return text.substring(1, text.length - 1)
    } else {
      return text
    }
  }

  const isValidCsvCell = (text: any) => {
    const pattern = getPattern()
    return new RegExp(pattern).test(text)
  }

  const getPattern = () => {
    if (config.textQualifier === "'") return /^'([^']|'')*'$/
    else return /^"([^"]|"")*"$/
  }

  return read(csvData)
}
